import { createAction } from '../../../utils/redux/createAction';
import { VITALS_ACTIVITY_TYPE } from '../../../components/PatientHealthboard/constants';

const actionsScope = 'profile/single-point-values-modal';

export const SINGLE_POINT_VALUES_MODAL = {
  OPEN: `${actionsScope}/open`,
  CLOSE: `${actionsScope}/close`,
};

export const singlePointValuesModalActions = {
  open: createAction(SINGLE_POINT_VALUES_MODAL.OPEN),
  close: createAction(SINGLE_POINT_VALUES_MODAL.CLOSE),
};

const initialState = {
  opened: false,
  monthTitle: '',
  entity: [],
  type: VITALS_ACTIVITY_TYPE.BMI,
  metricSettings: {},
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SINGLE_POINT_VALUES_MODAL.OPEN: {
      return {
        ...state,
        ...payload,
        opened: true,
      };
    }

    case SINGLE_POINT_VALUES_MODAL.CLOSE: {
      return { ...initialState };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/profiles/patientHealthboard/single-point-values-modal.js